export default function initNumericValidator() {
    $.validator.methods.number = function(value, element) {
        return this.optional(element) || /^-?(?:\d+|\d{1,3}(?:\.\d{3})+)(?:,\d{1,2})?$/.test(value);
    }

    $.validator.methods.range = function(value, element, param) {
        if (this.optional(element)) return true;
        if (typeof param[0] === 'number') {
            if (element.className.includes("currency-euro")) {
                value = value.replace(/\./g, '');
            }

            value = value.replace('.', '');
            value = parseFloat(value.replace(',', '.'));
        }
        return (value >= param[0] && value <= param[1]);
    }
}